import { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';

interface SpotQuotePhotoGridProps {
  photos: any[];
}

type PhotoSection = {
  stepName: string;
  stepIndex: number;
  photos: any[];
};

const buildSections = (photos: any[]): PhotoSection[] => {
  const sections: PhotoSection[] = [];
  const seen = new Map<number, PhotoSection>();

  for (const photo of photos) {
    const key = photo.step_index ?? 0;
    if (!seen.has(key)) {
      const section: PhotoSection = { stepName: photo.step_name || 'Uncategorized', stepIndex: key, photos: [] };
      seen.set(key, section);
      sections.push(section);
    }
    seen.get(key)!.photos.push(photo);
  }

  return sections;
};

const SpotQuotePhotoGrid: FC<SpotQuotePhotoGridProps> = ({ photos }) => {
  const sections = buildSections(photos ?? []);

  if (sections.length === 0) {
    return <Typography>No photos for this XOI Job</Typography>;
  }

  return (
    <>
      {sections.map((section, idx) => (
        <Box key={section.stepIndex} sx={{ mb: 4 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600, color: 'text.secondary' }}>
            {section.stepName}
          </Typography>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
            {section.photos.map((photo) => (
              <img
                key={photo.id}
                src={photo.url}
                alt={`Uploaded by ${photo.uploader}`}
                style={{
                  width: '100%',
                  height: '250px',
                  objectFit: 'contain',
                  backgroundColor: '#111',
                  borderRadius: '4px',
                }}
              />
            ))}
          </div>
          {idx < sections.length - 1 && <Divider sx={{ mt: 3 }} />}
        </Box>
      ))}
    </>
  );
};

export default SpotQuotePhotoGrid;
